import { api } from "@/services";
import { Address } from "@/types";
import { SharedServicesResponse } from "@/types/Shared";

const useBasicUpdateClientAddress = async (
  AddressToUpdate: Address[],
  email: string
): Promise<[Response: SharedServicesResponse, Error: string[], Loading: boolean]> => {
  var Response: SharedServicesResponse = null;
  var Error = null;
  var Loading = true;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp: { data: SharedServicesResponse } = await api.post(
        `/Client/UpdateAdressesClient?email=${email}`,
        AddressToUpdate,
        { signal: Controller.signal }
      );
      if (resp.data.status) {
        Response = resp.data;
      } else {
        Error = ["Erro ao tentar atualizar endereço!", resp.data.msgs];
      }
    } catch (error) {
      Error = ["Erro ao tentar atualizar endereço!", error.message];
    } finally {
      Loading = false;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, Error, Loading];
};

export { useBasicUpdateClientAddress };
